import styled from 'styled-components';
import { theme, toRem } from 'design';

const Breadcrumbs = styled.nav`
  position: relative;
  flex-flow: row nowrap;
  justify-content: flex-start;
  width: auto;
  height: auto;
  margin-bottom: ${toRem(theme.space.md)};
`;

export default Breadcrumbs;
